"use client";

import { BookOpenText } from 'lucide-react';

interface RelatedPostsHeadingProps {
  id?: string;
}

export function RelatedPostsHeading({ id }: RelatedPostsHeadingProps) {
  return (
    <h2 
      id={id}
      className="text-2xl md:text-3xl font-bold mb-6 flex items-center"
      aria-label="Related blog posts section"
    >
      <BookOpenText className="h-6 w-6 mr-3 text-primary" aria-hidden="true" />
      Other Posts You Might Like
    </h2>
  );
}
